import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles/index';

const styles = () => ({
    caption: {
        fontSize: '11px',
        color: '#999999',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    subheading: {
        fontSize: '15px',
        color: '#666666',
        marginTop: '16px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
});

function GridItem(props) {
    return (
        <Grid
            item
            xs={12}
            sm={6}
        >
            <Typography className={props.classes.subheading}>
                {props.children}
            </Typography>
            <Typography className={props.classes.caption}>
                {props.caption}
            </Typography>
        </Grid>
    );
}

GridItem.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    caption: PropTypes.string.isRequired,
};

export default withStyles(styles)(GridItem);



// WEBPACK FOOTER //
// ./src/app/common/components/Drawer/GridItem.js